import React from 'react'
import { Badge } from 'react-bootstrap'
import Name from '../../user/full-name'

const Enrollee = ({
    user = {}
}) => {
    return (
        <div
            style={{ padding: '0px 5px'}}
        >
            <Badge variant='secondary' style={{ whiteSpace: 'nowrap'}} >
                <Name user={user} />
            </Badge>
        </div>
    )
}

export default Enrollee